module.exports = __webpack_public_path__ + "img/aboutBanner02.6db4afbc.jpg";